<script lang="ts">
	import ExploreTripCardLoading from './blocks/ExploreTripCardLoading.svelte'
</script>

<div class="w-full py-2 mt-2 flex flex-col space-y-6">
	{#each [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as _, index}
		{#if index !== 0}
			<div class="h-[1px] rounded-full my-6 bg-brand-gray-4/25">
				<!-- space -->
			</div>
		{/if}
		<ExploreTripCardLoading />
	{/each}
</div>
